const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/hooks/countdown.ts';
import { useEffect, useState } from 'react';
import moment from 'moment';

const useCountdown = (startTime: moment.Moment, totalDuration: number) => {
    const [timeLeft, setTimeLeft] = useState(totalDuration);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = moment();
            const elapsed = moment.duration(now.diff(startTime)).asSeconds();

            // Math.max prohibits "remaining" to be negative
            const remaining = Math.max(0, totalDuration - elapsed);
            setTimeLeft(remaining);
            setProgress(Math.min((elapsed / totalDuration) * 100, 100));

            if (elapsed >= totalDuration) {
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [startTime, totalDuration]);

    return { timeLeft, progress };
};

export default useCountdown;
